/* vg-detail-buy.js - kulate tlacitko kosiku na detailu produktu
   ==============================================================
   Vygruntujeme.cz, 2026-08-20.

   CO DELA: na detailu produktu vlozi na sev mezi fotku a text kulate
   oranzove tlacitko s ikonou kosiku. Po kliknuti se z nej stane pilulka
   s poctem kusu (kos / minus - pocet - plus) - presne ta, kterou uz mame
   na kartach ve vypisu.

   PROC JS A NE LIQUID: sections/main-product.liquid ma 160 kB a
   themeFilesUpsert neumi castecnou upravu - musel by se posilat cely a
   to je u jednoho tlacitka zbytecne riziko. Stejnou cestou uz v projektu
   jde vlajka vyrobce (vg-brand-flag.js) i presun odznacku do galerie
   (funkce placeBadges ve snippets/vat-toggle.liquid).

   KAM SE VKLADA: jako prvni potomek .product-text, tedy textoveho
   sloupce hned pod galerii. Tlacitko se pak absolutne umisti k hornimu
   okraji toho sloupce (top: -26px), takze sedi pulkou na fotce a pulkou
   pod ni. Zamerne se NEVKLADA do .product-gallery-item: ta ma v
   assets/section-main-product.css overflow: hidden a horni polovina
   kolecka by se orizla.

   CHOVANI NEDELA TENHLE SOUBOR. Pocitadlo, nacteni kosiku, odesilani i
   dorovnavani resi assets/vg-card-grid.js - ten zna vedle karet i
   selektor .vg-detail-buy. Tady se jen vyrobi obal a tlacitko; pilulku
   .vg-qty do nej dokresli ensurePill() z vg-card-grid.js.

   ID VARIANTY se schvalne nikam nekopiruje. vg-card-grid.js si ho pro
   .vg-detail-buy cte primo z formulare na strance, takze prepnuti
   varianty (jina vune, jine baleni) je videt hned a nic se nemusi
   synchronizovat. */
(function () {
  'use strict';

  if (window.vgDetailBuyLoaded) return;
  window.vgDetailBuyLoaded = true;

  var ICON_CART =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<circle cx="9" cy="20" r="1.6"/><circle cx="18" cy="20" r="1.6"/>' +
    '<path d="M2 3h2.2l2.4 12.2a1.6 1.6 0 0 0 1.6 1.3h8.6a1.6 1.6 0 0 0 1.6-1.3L21 7H5"/>' +
    '</svg>';

  /* Tlacitko nema smysl u produktu, ktery se koupit neda. Rozhoduje
     pritomnost skutecneho tlacitka "Pridat do kosiku" ve formulari - to
     sablona u vyprodaneho produktu bud vubec nevykresli, nebo ho vypne.
     Kontroluje se az tady, ne v Liquidu, protoze se stav muze zmenit i
     prepnutim varianty. */
  function canBuy() {
    var atc = document.querySelector('.main-product .product-form .add-to-cart');
    return !!atc && !atc.disabled;
  }

  function build() {
    if (document.querySelector('.vg-detail-buy')) return true;

    var text = document.querySelector('.main-product .product-text');
    if (!text) return false;
    if (!canBuy()) return false;

    var wrap = document.createElement('div');
    wrap.className = 'vg-detail-buy';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'vg-cart-icon-btn';
    btn.setAttribute('aria-label', 'Přidat do košíku');
    btn.innerHTML = ICON_CART;

    wrap.appendChild(btn);
    text.insertBefore(wrap, text.firstChild);
    return true;
  }

  /* Galerie i textovy sloupec se na detailu dokresluji postupne (varianty,
     cena, dostupnost), proto se to zkousi vickrat. Jakmile obal existuje,
     build() sam skonci na prvnim radku. */
  function boot() {
    if (build()) return;
    setTimeout(build, 400);
    setTimeout(build, 1200);
    setTimeout(build, 2500);
  }

  /* --- ram galerie podle pomeru fotky (2026-08-23) -----------------
     Zadani klienta: u sirokych fotek (treba sest roli vedle sebe)
     zbyval pod obrazkem siroky prazdny pruh.

     PROC VZNIKAL: sablona dava dlazdici galerie pevny ctverec
     (inline padding-top: 100 % podle nastaveni product_card_aspect_ratio)
     a obrazek se do nej vklada cely, tedy s bilym mistem nad a pod.
     U ctvercoveho produktu to videt neni, u sirokeho ano.

     RESENI: vyska ramu se dopocita z pomeru stran prvni fotky. Nesahalo
     se na nastaveni motivu - to plati i pro desktop a pro vsechny
     produkty naraz; tohle je jen mobil a jen tam, kde to ma smysl.

     VSECHNY DLAZDICE DOSTANOU STEJNOU VYSKU, i kdyz maji ruzne fotky:
     jsou to slidy vedle sebe a ruzna vyska by posunula listovani.
     Rozhoduje proto prvni fotka.

     MEZE 45-100 %: klient chce usetrit co nejvic mista, takze spodni
     mez je nizko - 45 % sirky je porad prouzek, do ktereho se da trefit
     prstem i listovat v nem. Nad 100 % se nejde, u vysokych fotek by se
     ram zbytecne natahoval. */
  function fitGalleryFrame() {
    var gallery = document.querySelector('.main-product .product-gallery');
    if (!gallery) return false;

    /* Jedina fotka = jedna miniatura teze fotky. Nahledovy sloupec pak
       nema smysl, tak se schova (dela to CSS podle teto tridy) a fotka
       dostane celou sirku. */
    if (gallery.querySelectorAll('.product-gallery__thumbnails .thumbnail').length <= 1) {
      gallery.classList.add('vg-single-photo');
    }

    var img = gallery.querySelector('.product-gallery-item img');
    if (!img) return false;

    /* Pomer se cte z atributu width/height, ktere sablona zapisuje
       primo do <img>. Jsou v HTML od prvni chvile, takze se nemusi
       cekat na stazeni fotky - drive se cetlo naturalWidth a v pomalem
       nacitani (nahled motivu) uprava vubec nestihla probehnout.
       naturalWidth zustava jako zaloha, kdyby atributy chybely. */
    var w = parseFloat(img.getAttribute('width')) || img.naturalWidth;
    var h = parseFloat(img.getAttribute('height')) || img.naturalHeight;
    if (!w || !h) {
      if (!img.complete) img.addEventListener('load', fitGalleryFrame, { once: true });
      return false;
    }

    var pct = (h / w) * 100;
    pct = Math.max(45, Math.min(100, pct));
    gallery.style.setProperty('--vg-frame', pct.toFixed(2) + '%');
    return true;
  }

  function bootGalleryFrame() {
    if (fitGalleryFrame()) return;
    /* Galerie se v nekterych sablonach dokresluje az po prvnim
       vykresleni stranky. Zkousi se to proto dal, dokud se to nepovede,
       nejdele deset sekund - pak uz je jasne, ze na strance galerie
       neni (napr. produkt bez fotky). */
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      if (fitGalleryFrame() || tries > 20) clearInterval(timer);
    }, 500);
  }

  /* --- dalsi vune: ctyri dlazdice + tlacitko "vice" ----------------
     Zadani klienta 2026-08-20: pri osmi vunich zabiral blok pul
     obrazovky. Prvni pokus byl vodorovny posuvnik, ale klient spravne
     namitl, ze na nem neni poznat, ze se da posouvat a ze tam neco dal
     je. Proto viditelny prvek: ctyri dlazdice a pata je tlacitko s
     poctem zbyvajicich.

     PRAVE ZOBRAZENA VUNE ZUSTAVA VZDY VIDET, i kdyz je v poradi az
     osma - jinak by zakaznik nevidel, co vlastne ma vybrane. Do ctyrky
     se proto zapocitava jako prvni a v radku zustava na svem miste,
     jen se neschova.

     Skryva se pridanim tridy, ne odstranenim z DOM: po kliknuti staci
     tridu sundat a nic se nemusi znovu vykreslovat. Vzhled resi
     assets/vg-card-grid.css sekce 30 a plati jen do 1023 px - na
     desktopu se vsechny dlazdice vejdou a tlacitko je skryte CSSkem,
     takze tady netreba resit sirku okna. */
  var LINKED_VISIBLE = 4;

  function buildLinkedMore() {
    var box = document.querySelector('.main-product .product-text .vg-linked__items');
    if (!box) return false;
    if (box.getAttribute('data-vg-more') === '1') return true;

    var items = [].slice.call(box.children).filter(function (el) {
      return el.classList && el.classList.contains('vg-linked__item');
    });
    /* Kdyby zbyvala jedina dlazdice, tlacitko "vice" by zabralo stejne
       misto jako ona sama - to nema smysl. */
    if (items.length <= LINKED_VISIBLE + 1) return true;

    box.setAttribute('data-vg-more', '1');

    var current = [], others = [];
    items.forEach(function (el) {
      if (el.classList.contains('vg-linked__item--current')) current.push(el);
      else others.push(el);
    });
    var visible = current.concat(others).slice(0, LINKED_VISIBLE);
    var hidden = items.filter(function (el) { return visible.indexOf(el) === -1; });
    if (!hidden.length) return true;

    hidden.forEach(function (el) { el.classList.add('vg-linked__item--hidden'); });

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'vg-linked__more';
    btn.setAttribute('aria-label', 'Zobrazit dalsi vune');
    btn.innerHTML = '<strong>+' + hidden.length + '</strong><span>více</span>';
    btn.addEventListener('click', function () {
      hidden.forEach(function (el) { el.classList.remove('vg-linked__item--hidden'); });
      if (btn.parentNode) btn.parentNode.removeChild(btn);
    });
    box.appendChild(btn);
    return true;
  }

  function bootLinked() {
    if (buildLinkedMore()) return;
    setTimeout(buildLinkedMore, 600);
    setTimeout(buildLinkedMore, 1800);
  }

  /* --- "IHNED k vyzvednuti" i na detailu ---------------------------
     Navrh chce pod cenou stejne kratke hlaseni jako na kartach ve
     vypisu. Sablona sem pise "Dostupne k vyzvednuti na <nazev vydejny>",
     coz je na mobilu dlouhe na dva radky.

     Text prepisuje pickupCardText() ve snippets/vat-toggle.liquid, ale
     ta je omezena selektorem na .product-item, tedy jen na karty. Misto
     zasahu do 22 kB snippetu se stejna zmena dela tady, jen pro detail.

     Proc pozorovatel a ne jednorazovy prepis: obsah hlaseni dosazuje az
     assets/component-pickup-availability.js po odpovedi ze serveru a
     prepisuje ho znovu po kazde zmene varianty. Jednorazovy prepis by
     prezil jen do prvniho prekresleni. */
  /* ZADNE \b NA KONCI: v JavaScriptu je \w jen ASCII, takze "i" s carkou
     se nepocita za pismeno. Mezi "vyzvednuti" a nasledujici mezerou tim
     zadna hranice slova nevznikne a test by nikdy neprosel - overeno
     primo na strance 2026-08-20, vzorek
     "\n        Dostupne k vyzvednuti na Vygruntujeme vydejna\n      ". */
  var PICKUP_RE = /^\s*Dostupn[eé]\s+k\s+vyzvednut[ií]/i;

  function shortenPickup() {
    var box = document.querySelector('.main-product pickup-availability-compact .alert');
    if (!box) return;
    /* Jen hlaseni o dostupnosti. Vetu o doruceni do 72 hodin ani vyzvu
       "Vyberte prodejnu" prepisovat nesmime - nesou jinou informaci. */
    var txt = box.textContent;
    if (!PICKUP_RE.test(txt)) return;
    if (box.getAttribute('data-vg-short') === '1') return;
    box.setAttribute('data-vg-short', '1');

    /* Prepisuje se jen textovy uzel, ne cely obsah: uvnitr sedi jeste
       barevna tecka a pripadna ikona, ktere musi zustat. */
    var walker = document.createTreeWalker(box, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      if (PICKUP_RE.test(node.nodeValue)) {
        node.nodeValue = 'IHNED k vyzvednutí';
        break;
      }
    }
  }

  /* Tecka se prekresluje spolu s hlasenim, proto se atribut data-vg-short
     pri kazde zmene zahodi a text se posoudi znovu. */
  function watchPickup() {
    var host = document.querySelector('.main-product pickup-availability-compact');
    if (!host) return false;
    shortenPickup();
    new MutationObserver(function () {
      var box = host.querySelector('.alert');
      if (box && box.getAttribute('data-vg-short') !== '1') shortenPickup();
    }).observe(host, { childList: true, subtree: true, characterData: true });
    return true;
  }

  function bootPickup() {
    if (watchPickup()) return;
    setTimeout(watchPickup, 600);
    setTimeout(watchPickup, 1800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(); bootPickup(); bootLinked(); bootGalleryFrame();
    });
  } else {
    boot();
    bootPickup();
    bootLinked();
    bootGalleryFrame();
  }
})();
